export enum RecipeType{
    Auto=0, //only turbo
    AutoHard=1, //only turbo
    SemiAuto=2, //consistency and turbo
    SemiAutoTime=3, //time and turbo
    Slush=4, //consistency
    CoffeeSlush=5 //time 
}